import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import EmployerState from '../../features/employer-selection/application/domain/entities/employerState';

export interface IStates {
  states: Array<EmployerState>;
}

const initialState: IStates = {
  states: [],
};

export const statesSlice = createSlice({
  name: 'states',
  initialState,
  reducers: {
    setStates: (state, action: PayloadAction<Array<EmployerState>>) => {
      state.states = action.payload;
    },
  },
});

export const { setStates } = statesSlice.actions;
